
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nosotros/terminos-de-servicio",
      function () {
        return require("private-next-pages/nosotros/terminos-de-servicio.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nosotros/terminos-de-servicio"])
      });
    }
  